import { Icon, IconName } from "@silversea-ssc/ui-components-react";
import React from "react";
import * as styles from "./FeatureCard.module.scss";

interface FeatureCardProps {
  code?: string;
  name?: string;
}

const featuresMapping: { [key: string]: { icon: IconName } } = {
  BridgeSailings: {
    icon: "bridge-sailings"
  },
  GentlemenHosts: {
    icon: "gentlemen-host"
  },
  CulinaryVoyages: {
    icon: "culinary-sailings"
  },
  WineCruises: {
    icon: "wine-sailings"
  }
};

const FeatureCard: React.FC<React.PropsWithChildren<FeatureCardProps>> = ({
  code,
  name
}) => {
  if (!code) return null;

  const { icon } = featuresMapping[code] || {};

  return (
    <div className={styles.feature}>
      <Icon name={icon} size="2x" padding={false} className={styles.icon} />
      <div>{name}</div>
    </div>
  );
};

export default FeatureCard;
